<div class="component-wrapper">
  <lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="header-details-wrapper" [class.no-detail]="!shouldShowDetailView">
        @if (shouldShowDetailView) {
          <div class="details-brief">
            <div class="name-description-container">
              @if (callCost?.destination) {
                <div class="detail-container">
                  <h5>Destination</h5>
                  <div class="detail-item">{{ callCost?.destination }}</div>
                </div>
              }
              @if (callCost?.providerId) {
                <div class="detail-container">
                  <h5>Provider</h5>
                  <div class="detail-item">{{ callCost?.providerId }}</div>
                </div>
              }
              @if (callCost?.rate != undefined || callCost?.rate != null) {
                <div class="detail-container">
                  <h5>Rate</h5>
                  <div class="detail-item">${{ callCost?.rate | number : '1.2-4' }}</div>
                </div>
              }
            </div>
          </div>
        }
        <div class="right context-actions">
          <!-- <button      ProviderCallRates table doesn't have create or update user fields
          type="button"
          mat-button
          matTooltip="Info"
          aria-label="Call Cost Info"
          id="call-cost-detail-info"
          >
          <mat-icon>info</mat-icon>
        </button> -->
        @if (canDelete()) {
          <button
            type="button"
            mat-button
            [matMenuTriggerFor]="callCostMenu"
            aria-label="Call Cost Actions"
            matTooltip="More Actions"
            id="call-cost-detail-more-actions"
            >
            <mat-icon>more_horiz</mat-icon>
          </button>
        }
      </div>
    </div>
    <div class="detail-content">
      <ndt-two-column-layout>
        <div ndtRightColumn>
          @if (!shouldShowDetailView) {
            <div> No existing call costs. </div>
          }
          @if (shouldShowDetailView) {
            <mat-tab-group>
              <mat-tab label="General">
                <div class="mat-tab-indented">
                  <div class="fields-container">
                    <mat-form-field class="flex-half">
                      <mat-label>Destination</mat-label>
                      <input
                        matInput
                        autocomplete="off"
                        type="text"
                        [value]="callCost?.destination"
                        formControlName="destination"
                        id="destination"
                        required
                        />
                        @if (form.get('destination')?.hasError('required')) {
                          <mat-error>
                            Destination Field is Required.
                          </mat-error>
                        }
                        @if (form.get('destination')?.hasError('pattern')) {
                          <mat-error>
                            Destination Field cannot contain any special characters.
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field class="flex-half">
                        <mat-label>Provider</mat-label>
                        <input
                          matInput
                          autocomplete="off"
                          type="text"
                          formControlName="providerId"
                          id="providerId"
                          lcsStaticSelect
                          [lcsSingleSelect]="providerSelect"
                          (search)="providerSearch($event)"
                          (reset)="providerReset()"
                          />
                          <lcs-static-select #providerSelect [displayWith]="providerDisplayWith">
                            @for (provider of providers; track provider) {
                              <lcs-option [value]="provider">
                                {{ provider }}
                              </lcs-option>
                            }
                          </lcs-static-select>
                        </mat-form-field>
                      </div>
                      <div class="fields-container">
                        <mat-form-field class="flex-half">
                          <mat-label>Area</mat-label>
                          <input
                            matInput
                            autocomplete="off"
                            type="text"
                            [value]="callCost?.area"
                            formControlName="area"
                            id="area"
                            required
                            />
                            @if (form.get('area')?.hasError('required')) {
                              <mat-error>
                                Area Field is Required.
                              </mat-error>
                            }
                            @if (form.get('area')?.hasError('pattern')) {
                              <mat-error>
                                Area Field must be a valid number.
                              </mat-error>
                            }
                          </mat-form-field>
                          <mat-form-field class="flex-half">
                            <mat-label>Zone</mat-label>
                            <input
                              matInput
                              autocomplete="off"
                              type="text"
                              [value]="callCost?.zone"
                              formControlName="zone"
                              id="zone"
                              required
                              />
                              @if (form.get('zone')?.hasError('required')) {
                                <mat-error>
                                  Zone Field is Required.
                                </mat-error>
                              }
                              @if (form.get('zone')?.hasError('pattern')) {
                                <mat-error>
                                  Zone Field must be either 0 or 1.
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="fields-container">
                            <mat-form-field class="flex-half">
                              <mat-label>Rate</mat-label>
                              <span class="currency-input">
                                $<input
                                matInput
                                autocomplete="off"
                                type="text"
                                [value]="callCost?.rate | number : '1.2-4'"
                                formControlName="rate"
                                id="rate"
                                required
                                />
                              </span>
                              @if (form.get('rate')?.hasError('required')) {
                                <mat-error>
                                  Rate Field is Required.
                                </mat-error>
                              }
                              @if (form.get('rate')?.hasError('pattern')) {
                                <mat-error>
                                  Rate Field must be a valid amount.
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        </div>
                      </mat-tab>
                    </mat-tab-group>
                  }
                </div>
                <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
              </ndt-two-column-layout>
            </div>
          </form>
        </lcs-loading-overlay>
        <mat-menu #callCostMenu="matMenu">
          @if (canDelete()) {
            <button mat-menu-item type="button" (click)="onDeleteClick()" id="call-cost-delete">
              Delete
            </button>
          }
        </mat-menu>
      </div>
